// Projects
export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';

// Props Recieved
export const PROPS_RECIEVED_PROJECT_PAGE = 'PROPS_RECIEVED_PROJECT_PAGE';

// Categories
export const GET_CATEGORIESLIST_SUCCESS = 'GET_CATEGORIESLIST_SUCCESS';

// Props Recieved
export const PROPS_RECIEVED_CATEGORYLIST = 'PROPS_RECIEVED_CATEGORYLIST';

// Stories in Categroy
export const GET_PROJECTSINCATEGORY_SUCCESS = 'GET_PROJECTSINCATEGORY_SUCCESS';

// Props Recieved
export const PROPS_RECIEVED_PROJECTSINCATEGORY = 'PROPS_RECIEVED_PROJECTSINCATEGORY';

// Options
export const GET_OPTIONS_SUCCESS = 'GET_OPTIONS_SUCCESS';

// Props Recieved
export const PROPS_RECIEVED_OPTIONS = 'PROPS_RECIEVED_OPTIONS';

// Project Name when hovered in category page
export const PROJECT_NAME_IN_CATEGORY = 'PROJECT_NAME_IN_CATEGORY';


/** WEBPACK FOOTER **
 ** ./src/js/actions/action-types.js
 **/